export default __webpack_public_path__ + "static/media/t1.328326d0.jpg";